import { render } from "./AsyncContentLoader.vue?vue&type=template&id=59a8777e"
import script from "./AsyncContentLoader.vue?vue&type=script&lang=js"
export * from "./AsyncContentLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__